import { RootState } from '../../store';
export const selectPrincipalQuery = (state: RootState) => state.principalPage.query;
